export const Bar = props => (
  <div className='tooltip'>
    { props.data.date }:
    <span style={{ color: '#6BD16B' }}> { props.data.additions } additions</span>
    <span style={{ color: '#C16B6B' }}> { props.data.deletions } deletions</span>
  </div>
)

export const Line = ({ point: { data } }) => (
  <div className='tooltip'>
    <div>{ data.x }: <strong>{ data.y }</strong></div>
  </div>
)

export const Pie = props => (
  <div className='tooltip'>
    { props.datum.data.label }: { props.datum.data.value }
  </div>
)
